import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { parseLocationParams } from '../utils/utils';
import Page from '../components/page';
import AppBar from '../components/appBar';
import main from '../main';
import { apiGetVersionInfo } from '../api';
import { showToast } from '../components/dialog';
import Button from '../components/button';

export default function SuccessPage() {
  const location = useLocation();
  const [isWeixin, setIsWeixin] = useState(false);
  const [url, setUrl] = useState('');
  const [guideMask, setGuideMask] = useState(false);
  const [data, setData] = useState<{ goodsTitle?: string; orderSn?: string; time?: string }>({});
  useEffect(() => {
    let _data = parseLocationParams(location.search);
    setData(_data ?? {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadAppVersion();
  }, []);

  async function loadAppVersion() {
    let ua = (window.navigator.userAgent || '').toLowerCase();
    let _isWeixin = false;
    if (ua) {
      _isWeixin = ua.includes('micromessenger');
    }
    setIsWeixin(_isWeixin);
    if (_isWeixin) {
      return;
    }

    var isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; //android终端

    if (isAndroid) {
      try {
        var res = await apiGetVersionInfo(isAndroid ? 'android' : 'ios');
        var data = res.data;
        if (data.code === 200) {
          setUrl(data.data.downloadPath);
        }
      } catch (e) {}
    } else {
      setUrl(main.iosDownloadUrl);
    }
  }

  function handleDownload() {
    // showToast('isWeixin ' + isWeixin);
    // if (2 > 1) return;

    if (isWeixin && !guideMask) {
      setGuideMask(true);
      return;
    }
    if (url) {
      window.open(url);
    } else {
      showToast('暂未发布');
    }
  }

  return (
    <Page appBar={<AppBar title="付款成功" />} contentClassName="vw-100 vh-100 overflow-y pos-r">
      <img className="vw-100 h-450 pos-a z-0" src={main.pic('pic_success_bg.png')} alt="" />
      <div className="pos-r z-1 t-0 vw-100 d-flex-c ai-center">
        <img className="w-100 mt-20" src={main.pic('icon_success.png')} alt="" />
        <div className="font-size-16 font-widget-600 mt-10 text-color-primary">下单成功</div>
        <div className="vw-100">
          <div className="font-size-14 mh-30 mv-20 bg-color-white border-radius-10 p-10 text-color-3d">
            <div className="d-flex-r jc-between border-bottom pv-10">
              <div>商品名称</div>
              <div>{decodeURIComponent(data.goodsTitle ?? '')}</div>
            </div>
            <div className="d-flex-r jc-between border-bottom pv-10">
              <div>下单时间</div>
              <div>{decodeURIComponent(data.time ?? '')}</div>
            </div>
            <div className="d-flex-r jc-between pv-10">
              <div>订单编号</div>
              <div>{decodeURIComponent(data.orderSn ?? '')}</div>
            </div>
          </div>
        </div>
        <div className="w-200 mt-20">
          <Button type="primary" size="lg" long onClick={handleDownload}>
            下载APP
          </Button>
        </div>
        <img className="w-80 h-80 mt-20" src={main.pic('icon_logo.png')} alt="" />
        {/* <div className="font-size-18 mt-5">网上营业厅</div> */}
        <div className="font-size-18 mt-20 text-color-9 mb-60">应用市场搜："网上营业厅"下载APP</div>
      </div>
      {guideMask && (
        <div className="pos-a l-0 t-0 z-10 vw-100 vh-100 bg-color-3-t7" onClick={() => setGuideMask(false)}>
          <img className="bw-100" src={main.pic('pic_guide.png')} alt="" />
        </div>
      )}
    </Page>
  );
}
